import { render, staticRenderFns } from "./editItemsale.vue?vue&type=template&id=698f705f&scoped=true"
import script from "./editItemsale.vue?vue&type=script&lang=js"
export * from "./editItemsale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698f705f",
  null
  
)

export default component.exports